import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import AppValues from 'src/app/common/app.values';
import { GridTableBody, UserTableConstructorInfo } from 'src/app/interfaces/tables.interfaces';
import { ConnectionStatus } from 'src/app/swagger-api/model/connectionStatus';
import { CellActionTooltipValues, CellActionTypes } from '../../tables/components/cell-actions.type';
import { PatientLink } from '../relation-request.interface';
import { PatientLinkReceivedTable, PatientLinkSentTable, PatientLinkTable } from './patient-link-tables';
import { RelationRequestTables } from './table-creator.enum';
import { RelationRequestTableFactory } from './user-relation-requests-table';

const linkedRequestTooltipValues: CellActionTooltipValues = {
  [CellActionTypes.REMOVE]: 'TOOLTIP_UNLINK_PATIENT',
  [CellActionTypes.SEND_MSG]: 'TOOLTIP_SEND_MESSAGE',
};

const sentLinkRequestTooltipValues: CellActionTooltipValues = {
  [CellActionTypes.REMOVE]: 'TOOLTIP_REMOVE_REQUEST',
};

const receivedLinkRequestTooltipValues: CellActionTooltipValues = {
  [CellActionTypes.CONFIRM]: 'TOOLTIP_ACCEPT_REQUEST',
  [CellActionTypes.REJECT]: 'TOOLTIP_DECLINE_REQUEST',
};

export const patientLinkRowData: (linkRequest: PatientLink) => GridTableBody = (linkRequest: PatientLink) => {
  const created: string =
    new DatePipe('en-US').transform(
      linkRequest.acceptanceDate || linkRequest.invitationDate,
      AppValues.DATE_FORMAT_SHORT,
    ) ?? '';

  return {
    entityId: linkRequest.entityId,
    actorId: linkRequest.relatedUser.user_id,
    user: linkRequest.relatedUser,
    list: linkRequest.diseases,
    manage: { status: true, reason: ConnectionStatus.Verified },
    tooltipValues: linkedRequestTooltipValues,
    created,
  };
};

export const patientLinkReceivedRowData: (linkRequest: PatientLink) => GridTableBody = (linkRequest: PatientLink) => {
  return {
    ...patientLinkRowData(linkRequest),
    manage: { status: null, reason: null },
    tooltipValues: receivedLinkRequestTooltipValues,
  };
};

export const patientLinkSentRowData: (linkRequest: PatientLink) => GridTableBody = (linkRequest: PatientLink) => {
  return {
    ...patientLinkRowData(linkRequest),
    manage: { status: true, reason: ConnectionStatus.Pending },
    tooltipValues: sentLinkRequestTooltipValues,
  };
};

@Injectable()
export class PatientLinkTableFactory extends RelationRequestTableFactory<PatientLink> {
  public buildTableConstructorData(type: RelationRequestTables, items: PatientLink[]): UserTableConstructorInfo {
    switch (type) {
      case RelationRequestTables.PATIENT_LINKED_REQUESTS:
        return new PatientLinkTable().buildTableData(items);

      case RelationRequestTables.PATIENT_SENT_LINK_REQUEST:
        return new PatientLinkSentTable().buildTableData(items);

      case RelationRequestTables.PATIENT_RECEIVED_LINK_REQUEST:
        return new PatientLinkReceivedTable().buildTableData(items);

      default:
        return { header: [], body: [], attribute: null };
    }
  }
}
